import React, { useMemo } from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import * as am4charts from '@amcharts/amcharts4/charts';

import { IAccessPointUniqueDevicesTrend } from '../../../../services/core/accessPoints';
import { Tooltip } from '../../../../components/tooltip/tooltip';
import { StackedColumnsDateChart } from '@components/chart/stackedColumnsDateChart';

import './charts.css';
import { drawAccessPointSamplesXAxisLabels, formatTooltipHour } from './coreAccessPointSamples';
import { DateRange } from '..';

interface IProps {
  data: IAccessPointUniqueDevicesTrend[],
  dateRange: DateRange,
  onMount: (chart: am4charts.XYChart) => am4charts.XYChart
}

export const CoreAccessPointUniqueDevices = (props: IProps) => {
  const { data, dateRange } = props;
  const { t } = useTranslation('coreAccessPoints');
  const uniqueDevicesData = useMemo(() => data.some(d => d.deviceCount !== null) ? data : [], [data]);

  return (
    <div className="core-access-point-chart-section">
      <StackedColumnsDateChart<IAccessPointUniqueDevicesTrend>
        data={uniqueDevicesData}
        className="core-ap-unique-devices-by-time-chart"
        series={[{
          dataKey: 'deviceCount',
          description: t('UNIQUE_DEVICES'),
          visible: true,
          colour: '#5b9ad2',
        }]}
        title={
          <>
            {t('UNIQUE_DEVICES_BY_TIME')}{' '}
            <Tooltip popperContent={t('UNIQUE_DEVICES_BY_TIME_TOOLTIP')} placement="right">
              <i className="fa fa-question-circle" style={{ color: '#7490b9', cursor: 'pointer' }} />
            </Tooltip>
          </>
        }
        columnWidth={10}
        onMount={props.onMount}
        xAxisType={'date'}
        yAxisType={'value'}
        formatTooltipDate={formatTooltipHour}
        cypressId={'coreAccessPointUniqueDevicesByTime'}
        hasLegend={true}
        drawXAxis={(_, xAxis) => drawAccessPointSamplesXAxisLabels(xAxis as am4charts.DateAxis, dateRange)}
        useAxisTooltip
        bottomBorder
      />
    </div>
  );
};
